<template>
  <v-dialog
    :model-value="isDialogShow"
    :persistent="dialogSettings.persistent"
    :width="dialogSettings.width"
    @update:model-value="onDialogStateChange"
  >
    <component :is="dialogComponent" />
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import TermsOfUse from '@/components/TermsOfUse.vue';
import Privacy from '@/components/Privacy.vue';
import InvalidateProfileAlert from '@/components/InvalidateProfileAlert.vue';

export default {
  name: 'Dialog',
  components: {
    TermsOfUse,
    Privacy,
    InvalidateProfileAlert,
  },
  computed: {
    ...mapState({
      dialogContent: state => state.common.dialogContent,
      dialogSettings: state => state.common.dialogSettings,
      isDialogShow: state => state.common.isDialogShow,
    }),
    dialogComponent() {
      const contentMap = {
        termsOfUse: 'TermsOfUse',
        privacy: 'Privacy',
        invalidateProfileAlert: 'InvalidateProfileAlert',
      };
      return contentMap[this.dialogContent] || 'div';
    },
  },
  methods: {
    onDialogStateChange(showDialog) {
      if (!showDialog) {
        this.$store.dispatch('SET_DIALOG_STATE', false);
      }
    },
  },
};
</script>
